import React, { useEffect } from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';

import Header from '../components/Header/Header';
import Hero from '../components/Hero/Hero';
import About from '../components/About/About';
import Services from '../components/Services/Services';
import Testimonial from '../components/Testimonial/Testimonial';
import Contact from '../components/Contact/Contact';
import Footer from '../components/Footer/Footer';

import './HomePage.css';

const HomePage = () => {
  useEffect(() => {
    const header = document.querySelector(".nav-links");
    const hero = document.querySelector(".header");

    const handleScroll = () => {
      const heroBottom = hero.getBoundingClientRect().bottom;

      if (heroBottom <= 50) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    };
	
	//const scrollTop 	 = window.scrollY || document.documentElement.scrollTop;
	const viewportHeight = window.innerHeight;
	//const headerHeight   = Math.max(viewportHeight - scrollTop, 50);
	document.documentElement.style.setProperty(
		"--viewport-height",
		`${viewportHeight}px`
	);

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
        <Header />
		<div className="main-content">
        <Hero />
        <Services />
        <About />
        <Testimonial />
        <Contact />
        <Footer />
      </div>
    </div>
  );
};

export default HomePage;